import React from 'react';
import Blocks from './Blocks';
import { IPageFields } from '@/types/contentful';

export function HeroBlock({ heroBlock }: IPageFields) {
  const { sys, fields } = heroBlock ?? {};

  return <Blocks sys={sys} fields={fields} />;
}
